import { CheckboxGroup, Checkbox } from "@heroui/react";
import { SectorFilterOptions } from "../../types/enums";

interface ISectorFilterCheckboxGroup {
    selected: SectorFilterOptions;
    updateCheckboxSelection?: (value: SectorFilterOptions) => void;
}

const AccordionCheckboxGroup: React.FC<ISectorFilterCheckboxGroup> = ({ selected = SectorFilterOptions.ALL, updateCheckboxSelection }) => {   

    const handleChange = (value: SectorFilterOptions) => {
        updateCheckboxSelection?.(value);
    };
    return (
        <CheckboxGroup
            orientation="horizontal"
            color="secondary"
            value={selected ? [selected] : []}
            radius='full'
            size='sm'
        >
            <Checkbox 
                classNames={{ wrapper: 'm-0' }} 
                onChange={() => handleChange(SectorFilterOptions.ALL)} 
                isSelected={selected === SectorFilterOptions.ALL} 
                className="mx-0 px-0" 
                value={SectorFilterOptions.ALL} 
                color="success" 
            />
            <Checkbox 
                classNames={{ wrapper: 'm-0' }} 
                onChange={() => handleChange(SectorFilterOptions.FILTER)} 
                isSelected={selected === SectorFilterOptions.FILTER} 
                className="mx-0 px-0" 
                value={SectorFilterOptions.FILTER} 
                color="warning" 
            />
            <Checkbox 
                classNames={{ wrapper: 'm-0' }} 
                onChange={() => handleChange(SectorFilterOptions.NONE)} 
                isSelected={selected === SectorFilterOptions.NONE} 
                className="mx-0 px-0" 
                value={SectorFilterOptions.NONE} 
                color="danger" 
            />
        </CheckboxGroup>
    );
};

export default AccordionCheckboxGroup;
